export const GET_SHIFTS_ERROR = "redux_store:shifts.error.get";
export const ADD_SHIFT_ERROR = "redux_store:shifts.error.add";
export const UPDATE_SHIFT_ERROR = "redux_store:shifts.error.update";
export const DELETE_SHIFT_ERROR = "redux_store:shifts.error.delete";

export const GET_CLOSED_DAYS_ERROR = "redux_store:shifts.error.get_closed_days";
export const ADD_CLOSED_DAY_ERROR = "redux_store:shifts.error.add_closed_day";
export const UPDATE_CLOSED_DAY_ERROR = "redux_store:shifts.error.update_closed_day";
export const DELETE_CLOSED_DAY_ERROR = "redux_store:shifts.error.delete_closed_day";

export const ADD_SPECIAL_OPENING_ERROR = "redux_store:shifts.error.add_special_opening";



// WEBPACK FOOTER //
// ./src/errors/shifts.js